import Link from 'next/link'
import { FC, useEffect } from 'react'

import Icon from 'project/Icon'
import Card from 'components/base/Card'
import Button from 'components/base/forms/Button'
import classNames from 'classnames'
import trackIntent from 'common/trackIntent'
import WhatsAppPrice from 'components/WhatsAppPrice'

interface Props {
  className?: string
  condensed?: boolean
}

const WhatsAppBusinessCard: FC<Props> = ({ className, condensed = false }) => {
  useEffect(() => {
    void trackIntent('WHATSAPP_BUSINESS_CARD_VIEW')
  }, [])

  const handleClick = () => {
    void trackIntent('WHATSAPP_DASHBOARD_CLICK')
  }

  return (
    <Link
      href='/whatsapp-business'
      className={classNames(className, 'text-body')}
      onClick={handleClick}
    >
      <Card padding='none' className='overflow-hidden'>
        <div className='flex-row' style={{ minHeight: condensed ? 240 : 369 }}>
          {/* Left Column - Content */}
          <div className='col-6 d-flex flex-column ps-5 pt-5 pb-5'>
            {!condensed && (
              <div className='d-flex align-items-center gap-2 mb-3'>
                <Icon name='whatsapp' width={24} height={24} fill='body' />
                <span className='fw-bold'>WhatsApp Business</span>
              </div>
            )}

            {/* Title */}
            <h3 className='fw-bold mb-3' style={{ fontSize: 18 }}>
              Personalised WhatsApp Business Phone Number.
            </h3>

            {/* Description */}
            <p className='fw-semibold fs-lg mb-4'>
              Connect with your customers directly, immediately and more
              effectively with our WhatsApp for Business number service.
            </p>

            {!condensed && (
              <div className='mb-4'>
                <WhatsAppPrice />
              </div>
            )}

            {/* Button */}
            <div>
              <Button theme='sale'>Get Started</Button>
            </div>
          </div>

          {/* Right Column - Hero Image */}
          <div className='col-6 position-relative d-flex justify-content-center align-items-center'>
            <img
              src='/images/whatsapp/hero.png'
              alt='WhatsApp Business mascot'
              className='position-absolute bottom-0 end-0'
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
              }}
            />
          </div>
        </div>
      </Card>
    </Link>
  )
}

export default WhatsAppBusinessCard
